
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
@Component({})
export default class extends Vue {
  loading = true
  source = ''

  created() {
    this.getData()
  }

  async getData() {
    this.loading = true;
    let { error, data, message } = await this.$getDownload(
      "/manager/open-platform/get-store-qrcode",
      {
      },
      {
        auto: false,
        method: 'GET'
      }
    );
    this.loading = false;
    if (error) return this.$error(message || "小程序码加载失败");
    this.source = data;
  }
}

